import { Injectable } from '@angular/core';
import { ReportTableService } from './report-table-service';
import { TableService } from './table-service';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends ReportTableService {

 override baseUrl = '/report';

 override multilpleFilterBaseUrl = "/workorderstatus";
}